import React, { Component } from 'react';
import { clearData } from 'pages/store/actions/data';
import { entities } from 'pages/store/schema';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import NotFound from 'pages/views/generic/NotFound/index';
import Routes from 'pages/views/ecom/provisioning/routes';

class Provisioning extends Component {
  componentWillUnmount() {
    this.props.clearData();
  }

  render() {
    return (
      <Switch>
        {Routes}
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  clearData: () => dispatch(clearData(entities.ecomConfirmation)),
});

export default connect(null, mapDispatchToProps)(Provisioning);
